import { useState } from "react";
import { Badge, Button, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from "reactstrap";
import { toast } from "react-toastify";
import { disableServer } from "../../services/serversService";

export default function DisableServerButton({ machine, onDisabled }) {
  const [isOpen, setIsOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // passphrase_enabled is tri-state: true (active), false (disabled), null (never provisioned)
  if (machine?.passphrase_enabled === false) {
    return <Badge color="danger">Server disabled</Badge>;
  }
  if (machine?.passphrase_enabled !== true) return null;

  const handleClose = () => {
    if (isSubmitting) return;
    setIsOpen(false);
  };

  const handleConfirm = async () => {
    setIsSubmitting(true);
    try {
      await disableServer(machine.id);
      toast.success(`Server ${machine.hostname} disabled`);
      onDisabled?.();
      setIsOpen(false);
    } catch (ex) {
      if (ex.response?.status === 409) {
        toast.error(ex.response.data?.detail ?? "This server has no passphrase to disable");
      } else {
        toast.error("Failed to disable server");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Button color="danger" size="sm" onClick={() => setIsOpen(true)}>
        <i className="fas fa-lock mr-1" />
        Disable server
      </Button>

      <Modal isOpen={isOpen} toggle={handleClose} size="md" contentClassName="bg-modal">
        <ModalHeader toggle={handleClose}>Disable server</ModalHeader>
        <ModalBody>
          <p>
            Are you sure you want to disable <strong>{machine.hostname}</strong>?
          </p>
          <p className="text-muted small mb-0">
            Its boot passphrase will no longer be served: the encrypted folders will stay locked at the next reboot. Use
            this only if the server is lost or stolen. This cannot be undone from the dashboard.
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={handleClose} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button color="danger" onClick={handleConfirm} disabled={isSubmitting}>
            {isSubmitting ? <Spinner size="sm" /> : "Confirm — Disable server"}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}
